import React, { useEffect } from 'react';
import { useMsal } from "@azure/msal-react";
import { useNavigate } from 'react-router-dom'; 

function RedirectHandler() {
    const { instance } = useMsal();
    const navigate = useNavigate(); // Um nach der Authentifizierung zu einer anderen Seite zu navigieren

    useEffect(() => {
        
        instance.handleRedirectPromise()
            .then(authResult => {
                if (authResult) {
                    // Speichern des Access-Tokens im lokalen Speicher
                    const accessToken = authResult.accessToken;
                    sessionStorage.setItem('token', accessToken);
                    console.log("Access Token erhalten: ", accessToken);
                    navigate('/home'); 
                }
            })
            .catch(error => {
                console.error('Authentication error:', error);
            });
    }, [instance, navigate]);

    return (
        <div>
            <h1>Authentifizierung läuft...</h1>
        </div>
    );
}

export default RedirectHandler;